import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Units } from '@product/const';
import { PriceService, SelectedPriceService } from '@product/data-access';
import { SdvorClickOutsideDirective, SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { BehaviorSubject, Observable, ReplaySubject, combineLatest } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'sd-unit-tab',
  templateUrl: './unit-tab.component.html',
  styleUrls: ['./unit-tab.component.scss'],
  imports: [AsyncPipe, SdvorClickOutsideDirective, SdvorIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnitTabComponent implements OnInit {
  isOpen$ = new BehaviorSubject(false);

  @Input() set productCode(value: string) {
    this.productCode$.next(value);
  }

  @Input() units: Units[];

  selectedUnitCode$: Observable<string>;
  selectedUnitName$: Observable<string>;
  productCode$ = new ReplaySubject<string>(1);
  private selectUnitCodeSubject$ = new ReplaySubject<string>(1);

  constructor(
    private priceService: PriceService,
    private selectedPriceService: SelectedPriceService,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.selectedUnitCode$ = this.productCode$.pipe(
      switchMap((productCode) =>
        this.selectedPriceService.getSelectedPrice(productCode).pipe(map((price) => price.unit?.code)),
      ),
    );

    this.selectedUnitName$ = this.productCode$.pipe(
      switchMap((productCode) =>
        this.selectedPriceService.getSelectedPrice(productCode).pipe(map((price) => price.unit?.name)),
      ),
    );

    combineLatest({ productCode: this.productCode$, unitCode: this.selectUnitCodeSubject$ })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(({ productCode, unitCode }) => {
        this.priceService.loadPricesIfNeed(productCode);
        this.selectedPriceService.selectPriceByUnitCode(productCode, unitCode);
      });
  }

  toggleDropdown(): void {
    this.isOpen$.next(!this.isOpen$.value);
  }

  closeDropdown(): void {
    this.isOpen$.next(false);
  }

  selectUnitCode(unitCode: string): void {
    this.selectUnitCodeSubject$.next(unitCode);
    this.isOpen$.next(!this.isOpen$.value);
  }

  onDropdownClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
  }
}
